/* eslint-disable @typescript-eslint/no-unused-vars */
import { APP_PROFILE } from 'env';
import { getQueryParamFromSearch } from 'utils/utils';
import Axios from 'axios';
import { createContext, useContext, useEffect, useState } from 'react';
import { defaultSteps, partnersSteps } from './profile.config';

export const getUtmSource = () => {
    const utmSource = getQueryParamFromSearch('utm_source');

    const blackList = [
        'google',
        'adwords',
        'adword',
        'facebook',
        'bing',
        'android',
        'taboola',
        'vendedoor',
        'trustpilot',
        'blog',
        'rd',
        'email',
        'twitter',
        'linkedin',
        'instagram',
        'landing',
    ];

    if (utmSource && !blackList.includes(utmSource.toString())) {
        return utmSource;
    }

    return null;
};

export const getUtmMedium = () => getQueryParamFromSearch('utm_medium');

const getLogoUrl = (utmSource: string, extension = 'jpg'): string => {
    const url = `https://assets.bizcapital.com.br/logos/parceiros/${utmSource}.jpg`;
    try {
        let response = Axios.get(url).then(value => response = value);
        if (response.status === 200) {
            return url;
        }
    } catch (error) {
        return `https://assets.bizcapital.com.br/logos/parceiros/${utmSource}.png`;
    }
    return `https://assets.bizcapital.com.br/logos/parceiros/${utmSource}.png`;
};

const hasCustomPage = async (utmSource: string): Promise<boolean> => {
    let responseValue = false;

    try {
        const response = await Axios.get(getLogoUrl(utmSource));

        if (response.status === 200) {
            responseValue = true;
        } else {
            responseValue = false;
        }
    } catch (error) {
        responseValue = false;
    }

    return responseValue;
};

const contextProps = {
    profile: APP_PROFILE,
    steps: APP_PROFILE === 'default' ? defaultSteps : partnersSteps,
};

export const ProfileContext = createContext({
    isPartner: null,

    setIsPartner: (isPartner) => {},
    logo: null,
    loanApplicationUtmSource: '',

    setLoanApplicationUtmSource: (utmSource: string) => {},
    loanApplicationUtmMedium: '',

    setLoanApplicationUtmMedium: (utmMedium: string) => {},
    ...contextProps,
});

const { Provider, Consumer } = ProfileContext;

export const ProfileProvider = ({ children }) => {
    const utmSource = getUtmSource();
    const utmMedium = getUtmMedium();

    const [isPartner, setIsPartner] = useState(
        utmSource === null ? false : null
    );
    const [logo, setLogo] = useState(null);
    const [loanApplicationUtmSource, setLoanApplicationUtmSource] =
        useState<string>(utmSource);
    const [loanApplicationUtmMedium, setLoanApplicationUtmMedium] =
        useState<string>(utmMedium);

    useEffect(() => {
        if (utmSource) {
            hasCustomPage(utmSource).then((value) => {
                setIsPartner(value);

                if (value === true) {
                    setLogo(getLogoUrl(utmSource));
                }
            });
        } else {
            setLogo(null);
        }
    }, []);

    useEffect(() => {
        if (loanApplicationUtmSource) {
            hasCustomPage(loanApplicationUtmSource).then((value) => {
                setIsPartner(value);

                if (value === true) {
                    setLogo(
                        getLogoUrl(loanApplicationUtmSource)
                    );
                }
            });
        } else {
            setLogo(null);
        }
    }, [loanApplicationUtmSource]);

    return (
        <Provider
            value={{
                isPartner,
                setIsPartner,
                logo,
                loanApplicationUtmSource,
                setLoanApplicationUtmSource: (newUtmSource) => {
                    setLoanApplicationUtmSource(newUtmSource);
                },
                loanApplicationUtmMedium,
                setLoanApplicationUtmMedium: (newUtmMedium) => {
                    setLoanApplicationUtmMedium(newUtmMedium);
                },
                ...contextProps,
            }}
        >
            {children}
        </Provider>
    );
};

const useProfile = () => useContext(ProfileContext);

export { useProfile };

export const ProfileConsumer = Consumer;
